import { Fragment } from "react";

import { getInterventionInfo } from "features/cdm/constants/formOptions";
import { ensureAbsoluteUrl } from "features/cdm/utils/ensureAbsoluteUrl";

// Splits on a URL (http(s):// or www.) keeping the URL as its own segment.
const URL_SPLIT_PATTERN = /((?:https?:\/\/|www\d?\.)[^\s]+)/g;
const URL_PATTERN = /^(?:https?:\/\/|www\d?\.)[^\s]+$/;

// Renders an info string, turning any URL into a link that opens in a new tab.
const InfoText = ({ info }) =>
  info.split(URL_SPLIT_PATTERN).map((part, index) =>
    URL_PATTERN.test(part) ? (
      <a
        key={index}
        href={ensureAbsoluteUrl(part)}
        target="_blank"
        rel="noreferrer noopener"
      >
        {part}
      </a>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    )
  );

// Renders the under-input `info` hint for each selected MECC intervention value
// (URL / helpline / description). Selected values with no `info` render nothing.
export const InterventionInfoHints = ({
  options,
  selectedValues = [],
  className,
}) =>
  selectedValues.map((value) => {
    const info = getInterventionInfo(options, value);

    return info ? (
      <p key={value} className={className}>
        <InfoText info={info} />
      </p>
    ) : null;
  });
